/**
 * Status filter / sort order for Library Requests grids.
 * Aligned with VQQ lifecycle shown on RFI Details (ticket 14746).
 * Archived is last; omitted from sponsor/vendor filters unless `includeArchived`.
 */
export const LIBRARY_REQUEST_STATUS_ORDER = [
  "Sent",
  "In Progress",
  "In Review",
  "In Remediation (Vendor)",
  "In Remediation (Purchaser)",
  "Pending",
  "Released",
  "Complete",
  "Cancelled",
  "Rejected",
  "Archived",
];

/** Open / in-flight statuses where Library Requests "View Details" applies. */
export const LIBRARY_REQUEST_OPEN_STATUSES = [
  "Pending",
  "Sent",
  "In Progress",
  "In Review",
  "In Remediation (Vendor)",
  "In Remediation (Purchaser)",
];

/**
 * @param {{ includeArchived?: boolean }} [opts]
 */
export function getLibraryRequestStatusFilterOptions({
  includeArchived = false,
} = {}) {
  const ids = includeArchived
    ? LIBRARY_REQUEST_STATUS_ORDER
    : LIBRARY_REQUEST_STATUS_ORDER.filter((s) => s !== "Archived");

  return ids.map((statusID) => ({
    statusID,
    label: statusID,
    checked: false,
  }));
}

/**
 * Filter-panel column descriptor shared by sponsor / vendor / admin Library grids.
 * @param {{ includeArchived?: boolean }} [opts]
 */
export function getLibraryRequestStatusFilterColumn({
  includeArchived = false,
} = {}) {
  const options = getLibraryRequestStatusFilterOptions({ includeArchived });
  return {
    id: "status",
    name: "Status",
    searchable: false,
    options,
    total: options.length,
  };
}

/**
 * @param {string | null | undefined} status
 * @returns {boolean}
 */
export function isLibraryRequestOpenStatus(status) {
  if (status == null || status === "") return false;
  const lc = String(status).toLowerCase();
  return LIBRARY_REQUEST_OPEN_STATUSES.some((s) => s.toLowerCase() === lc);
}
